export default __webpack_public_path__ + "static/media/raccoon.57403684.webp";